<template>
  <div class="add-material-limit">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInputDropdown
          label="Поиск материала"
          placeholder="Введите название..."
          :value="materialSearchValue"
          :options="materialOptions"
          option-value-key="material_id"
          option-label-key="label"
          :loading="materialSearchLoading"
          @change_input="onMaterialSearch"
          @select_item="onMaterialSelect"
        />
      </div>
      <div v-if="selectedMaterial" class="form__item selected-material">
        <span class="label">Материал:</span>
        <span>{{ selectedMaterial.label }}</span>
      </div>
      <div class="form__item">
        <CustomInput
          label="Лимит"
          type="number"
          :required="true"
          :value="formData.limit_amount"
          @change_input="(val) => (formData.limit_amount = val)"
        />
      </div>
      <CustomModalFooter
        :btn-loading="loading"
        submit-btn-text="Добавить"
        :disable-submit="!canSubmit"
      />
    </q-form>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from "vue";
import CustomInput from "@/components/form/CustomInput";
import CustomInputDropdown from "@/components/form/CustomInputDropdown";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { searchMaterialsForLimit } from "@/views/handbook/MaterialLimits/services";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  closeModal: {
    type: Function,
    default: () => {},
  },
});

const loading = ref(false);
const controller = ref(null);
const materialSearchValue = ref("");
const materialOptions = ref([]);
const materialSearchLoading = ref(false);
const selectedMaterial = ref(null);

const formData = reactive({
  limit_amount: "",
});

const projectTypeId = computed(() => props.data?.project_type_id);

const canSubmit = computed(
  () =>
    selectedMaterial.value &&
    formData.limit_amount !== "" &&
    Number(formData.limit_amount) >= 0
);

async function onMaterialSearch(searchValue) {
  materialSearchValue.value = searchValue;
  if (!searchValue || searchValue.length < 2) {
    materialOptions.value = [];
    return;
  }
  if (controller.value) {
    controller.value.abort();
  }
  controller.value = new AbortController();
  materialSearchLoading.value = true;
  const res = await searchMaterialsForLimit(
    searchValue,
    controller.value.signal
  );
  materialSearchLoading.value = false;
  materialOptions.value = res || [];
}

function onMaterialSelect(_value, item) {
  if (!item) return;
  selectedMaterial.value = item;
  materialSearchValue.value = item.label;
  materialOptions.value = [];
}

async function onSubmit() {
  if (!canSubmit.value || !projectTypeId.value) return;
  loading.value = true;
  const body = {
    material_id: selectedMaterial.value.material_id,
    limit_amount: parseFloat(formData.limit_amount),
  };
  await props.data?.onSubmit(projectTypeId.value, body);
  loading.value = false;
}
</script>

<style scoped lang="scss">
.add-material-limit {
  max-width: 500px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
  }
}

.selected-material {
  .label {
    font-weight: 500;
    margin-right: 8px;
  }
}
</style>
